import { jsx as _jsx } from "react/jsx-runtime";
import { CSSTransition } from "react-transition-group";
import React, { memo } from "react";
import styles from "./styles.module.css";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
const ButtonBar = (props) => {
    const { isHyrox } = props;
    const contents = (_jsx("div", { className: `${!props.showBottom ? styles.hideButtonBar : ""} ${!props.isHyrox ? styles.bottomRibbonContainer : ""}`, children: _jsx("div", { className: `${styles.buttonsDiv} ${props.scrolledToBottom ? styles.default : styles.scroll}`, children: _jsx(RoundedGainfulButton, { onClick: props.gonext, disabled: props.disabled, label: props.label.toLocaleUpperCase(), extraClassName: styles.nextBtn }) }) }));
    if (isHyrox)
        return contents;
    return (_jsx(CSSTransition, { in: props.showBottom, timeout: props.isHyrox ? 0 : 200, classNames: props.isHyrox
            ? { enterDone: styles.MyClassEnterDone }
            : {
                enterActive: styles.MyClassEnterActive,
                enterDone: styles.MyClassEnterDone,
                exitActive: styles.MyClassExit,
                exitDone: styles.MyClassExitActive,
            }, children: contents }));
};
export default memo(ButtonBar);
